export default __webpack_public_path__ + "static/22_19-b039bd0940249b9f8b6a3ed68d647f7f.png";